import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as dms from '../../../dms'
import * as routeBound from '../../../route-bound'
import * as organizations from '../../organizations'
import * as reports from '../../reports'

import { Api } from './api.service'
import * as effects from './effects'
import * as plugins from './plugins'
import type { TypeParams } from './types'

const DEFAULT_QUANTITY = 20

/** Sponsored accounts that are not assigned to a Space record. */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: payroll => payroll.id,
      name: ec.Name.Predefined.SpaceUnassignedSponsoredAccount,
      plugins: {
        additionalFactories: [
          new plugins.organizationDimensionFilter.Factory(),
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity: { id } }) => ({
              iconsConfigs: [
                {
                  class: 'atn-icon atn-comment atn-blue',
                  onClick: () =>
                    collection.plugins.editingPlugin.feature.actions.edit
                      .from(`Table.Row-${id}.Icons.Comment.Clicked`)
                      .dispatch({ id }),
                  title: 'Edit comment',
                },
              ],
            }),
          })),
        ],
        currentList: {
          quantity: {
            get: quantity => quantity ?? DEFAULT_QUANTITY,
          },
        },
      },
    })

    const organizationsFeature = ngCore.inject(organizations.Feature)
    const schemaFeature = ngCore.inject(dms.schema.Feature)

    const reportsEc = ngCore.inject(reports.Collection)

    this.feature.registerEffects(
      effects.loadOrganizationsOnListLoad(
        this,
        organizationsFeature,
        schemaFeature,
      ),
      effects.mirrorOrganizationFilterToReport(
        this,
        this.plugins.lookup(plugins.organizationDimensionFilter.Plugin).get(),
        reportsEc.plugins
          .lookup(reports.plugins.organizationDimensionFilter.Plugin)
          .get(),
      ),
    )
  }
}
